<template>
  <form @submit.prevent="aiRequest">

    <div class="form-group">
      <label for="exampleInputEmail1">توضیحات تغییرات</label>
      <textarea class="form-control" v-model="message" rows="12" cols="12"></textarea>
    </div>

    <div class="form-group">
      <label>عکس طرح (اختیاری)</label>
      <input
          type="file"
          class="form-control-file"
          accept="image/*"
          @change="onImageSelected"
      >
      <small class="form-text text-muted">اسکرین یا عکس طرح را بفرست تا از روی آن بسازد.</small>
      <div v-if="imagePreview" class="mt-2">
        <img :src="imagePreview" alt="طرح" class="ai-image-preview">
        <button type="button" class="btn btn-sm btn-outline-secondary mt-2" @click="clearImage">حذف عکس</button>
      </div>
    </div>

    <div class="">
      {{ result }}
    </div>
    <code>
      {{ code }}
    </code>


    <div class="text-center">
      <button class="btn btn-primary w-75">ثبت</button>
    </div>


  </form>
</template>

<script>
import {getAxiosInstance} from "@moeinmdn/mixitweb-front-modules/src/plugin/utils/setInstance";
import {generateHash} from "@moeinmdn/mixitweb-front-modules/src/plugin/Modules/Loan";
import * as miwComponents from '@moeinmdn/miw-alpha-components/src/package/IndexComponentMap'

const FAKE_NAME_ALIASES = {
  'm-text': 'm-p',
  'm-heading': 'm-h2',
  'm-title': 'm-h2',
  'm-paragraph': 'm-p',
  'm-image': 'm-img',
  'm-picture': 'm-img',
  'm-link': 'm-a',
  'm-anchor': 'm-a',
  'm-btn': 'm-button',
  'm-container': 'm-div',
  'm-wrapper': 'm-div',
  'm-row': 'm-div',
  'm-col': 'm-div',
  'm-column': 'm-div',
}

export default {
  name: "AiComponent",
  props: {
    layer: {}
  },
  data() {
    return {
      message: '',
      result: '',
      code: '',
      imageDataUrl: '',
      imagePreview: '',
    }
  },
  methods: {
    onImageSelected(event) {
      const file = event && event.target && event.target.files && event.target.files[0]
      if (!file) {
        this.clearImage()
        return
      }
      this.fileToDataUrl(file).then((dataUrl) => {
        this.imageDataUrl = dataUrl
        this.imagePreview = dataUrl
      }).catch((err) => {
        console.error('image read error', err)
        this.clearImage()
      })
    },
    clearImage() {
      this.imageDataUrl = ''
      this.imagePreview = ''
    },
    fileToDataUrl(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onerror = () => reject(new Error('read failed'))
        reader.onload = () => {
          const result = reader.result
          this.compressDataUrl(String(result)).then(resolve).catch(() => resolve(result))
        }
        reader.readAsDataURL(file)
      })
    },
    compressDataUrl(dataUrl) {
      return new Promise((resolve) => {
        const image = new Image()
        image.onload = () => {
          const max = 1400
          let {width, height} = image
          if (width > max || height > max) {
            const scale = Math.min(max / width, max / height)
            width = Math.round(width * scale)
            height = Math.round(height * scale)
          }
          const canvas = document.createElement('canvas')
          canvas.width = width
          canvas.height = height
          const ctx = canvas.getContext('2d')
          ctx.drawImage(image, 0, 0, width, height)
          resolve(canvas.toDataURL('image/jpeg', 0.82))
        }
        image.onerror = () => resolve(dataUrl)
        image.src = dataUrl
      })
    },
    cloneJson(value) {
      return JSON.parse(JSON.stringify(value))
    },
    componentCatalog() {
      const byName = {}
      Object.values(miwComponents).forEach(item => {
        if (!item || !item.name) return
        const path = String(item.path || '').replace('./', '')
        const parts = path.split('/').filter(Boolean)
        const tagName = parts[parts.length - 1] || ''
        const folder = parts[0] || ''
        byName[item.name] = {
          name: item.name,
          slots: item.slots || [],
          detail: {tag: {folder, name: tagName}},
        }
      })
      return byName
    },
    indexLayers(layer, map = {}) {
      if (!layer || typeof layer !== 'object') return map
      if (layer.id) map[String(layer.id)] = layer
      const slots = layer.slots && typeof layer.slots === 'object' ? layer.slots : {}
      Object.keys(slots).forEach(key => {
        const children = slots[key] && Array.isArray(slots[key].components)
            ? slots[key].components
            : []
        children.forEach(child => this.indexLayers(child, map))
      })
      return map
    },
    catalogEntry(name, catalog) {
      if (!name || !catalog[name]) return null
      return catalog[name]
    },
    resolveNewComponentName(node, catalog) {
      const rawName = node && node.name
      if (this.catalogEntry(rawName, catalog)) return this.catalogEntry(rawName, catalog)

      const tag = node && node.props && node.props.tag
      if (tag && this.catalogEntry(`m-${tag}`, catalog)) {
        return this.catalogEntry(`m-${tag}`, catalog)
      }

      const alias = FAKE_NAME_ALIASES[rawName]
      if (alias && this.catalogEntry(alias, catalog)) {
        return this.catalogEntry(alias, catalog)
      }

      const hasText = !!(node && node.props && (node.props.text || node.props.tag))
      return this.catalogEntry(hasText ? 'm-p' : 'm-div', catalog)
    },
    lockExistingIdentity(node, original) {
      node.id = original.id
      node.name = original.name
      if (original.detail) node.detail = this.cloneJson(original.detail)
      if (original.rawProps) node.rawProps = this.cloneJson(original.rawProps)
      if (original.componentType != null) node.componentType = original.componentType
      if (original.page != null) node.page = original.page
    },
    applyCatalogIdentity(node, entry) {
      node.name = entry.name
      node.detail = this.cloneJson(entry.detail)
    },
    isTextComponent(name) {
      return /^m-(p|h[1-5]|span|small|strong|a|button|li)$/.test(name || '')
    },
    cleanSlotText(node, text, slotName) {
      if (text == null) return ''
      const value = String(text).trim()
      const placeholders = ['default', 'slot', 'text', 'undefined', 'null', slotName, 'p-1', 'p-2', 'p-3', 'p-4']
      if (placeholders.includes(value.toLowerCase())) return ''
      if (!this.isTextComponent(node && node.name)) return ''
      return String(text)
    },
    sanitizeAiLayer(aiLayer, originalLayer) {
      if (!aiLayer || typeof aiLayer !== 'object') return originalLayer
      const catalog = this.componentCatalog()
      const originals = this.indexLayers(originalLayer)
      const walk = (node) => {
        if (!node || typeof node !== 'object') return null
        const original = node.id ? originals[String(node.id)] : null
        if (original) {
          this.lockExistingIdentity(node, original)
        } else {
          const entry = this.resolveNewComponentName(node, catalog)
          if (!entry) return null
          this.applyCatalogIdentity(node, entry)
        }

        if (!node.slots || typeof node.slots !== 'object') {
          node.slots = original && original.slots
              ? this.cloneJson(original.slots)
              : {}
        }

        Object.keys(node.slots).forEach(slotName => {
          const slot = node.slots[slotName]
          if (!slot || typeof slot !== 'object') return
          slot.text = this.cleanSlotText(node, slot.text, slotName)
          const children = Array.isArray(slot.components) ? slot.components : []
          slot.components = children.map(child => walk(child)).filter(Boolean)
        })

        if (original && original.slots) {
          Object.keys(original.slots).forEach(slotName => {
            if (!node.slots[slotName]) {
              node.slots[slotName] = this.cloneJson(original.slots[slotName])
            }
          })
        }
        return node
      }

      const sanitized = walk(this.cloneJson(aiLayer)) || this.cloneJson(originalLayer)
      if (originalLayer && originalLayer.id) {
        this.lockExistingIdentity(sanitized, originalLayer)
      }
      return sanitized
    },

    isAiPayload(obj) {
      if (!obj || typeof obj !== 'object') return false
      return Boolean(
          obj.updated_json
          || obj.global_style != null
          || obj.css_block
          || (Array.isArray(obj.actions) && obj.actions.length)
          || obj.explanation
      )
    },
    unwrapAiPayload(data) {
      if (!data) return null
      if (typeof data === 'string') {
        return this.extractJSON(data) || this.tryParse(data)
      }
      if (this.isAiPayload(data)) return data
      if (this.isAiPayload(data.output)) return data.output
      const first = Array.isArray(data) ? data[0] : null
      if (this.isAiPayload(first?.output)) return first.output
      if (this.isAiPayload(first)) return first
      return data
    },
    normalizeAiResponse(data) {
      return this.unwrapAiPayload(data)
    },
    upsertCssBlock(currentCss, cssBlock) {
      const block = (cssBlock || '').trim()
      if (!block) return currentCss || ''

      const selectorMatch = block.match(/^([^\{]+)\{/m)
      if (!selectorMatch) {
        const base = (currentCss || '').trim()
        return base ? `${base}\n\n${block}` : block
      }

      const selector = selectorMatch[1].trim().replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&')
      const blockRegex = new RegExp(`(${selector}\\s*\\{[\\s\\S]*?\\})`, 'm')
      const source = currentCss || ''

      if (blockRegex.test(source)) {
        return source.replace(blockRegex, block)
      }
      return source.trim() ? `${source.trim()}\n\n${block}` : block
    },
    async applyGlobalCss(res) {
      let nextCss = this.$store.getters['Site/getGlobalStyle'] || ''
      let changed = false

      if (typeof res.global_style === 'string') {
        nextCss = res.global_style
        changed = true
      }

      if (typeof res.css_block === 'string' && res.css_block.trim()) {
        nextCss = this.upsertCssBlock(nextCss, res.css_block)
        changed = true
      }

      const actions = Array.isArray(res.actions) ? res.actions : []
      for (const action of actions) {
        const tool = action?.tool
        const css = action?.css ?? action?.global_style
        if (typeof css !== 'string') continue

        if (tool === 'setGlobalStyle') {
          nextCss = css
          changed = true
        } else if (tool === 'upsertCssBlock' || tool === 'appendGlobalStyle') {
          nextCss = tool === 'appendGlobalStyle'
              ? `${(nextCss || '').trim()}\n\n${css.trim()}`.trim()
              : this.upsertCssBlock(nextCss, css)
          changed = true
        }
      }

      if (changed) {
        await this.$store.dispatch('Site/setGlobalStyle', nextCss)
      }
      return changed
    },
    tryParse(text) {
      try {
        return JSON.parse(text)
      } catch (e) {
        return null
      }
    },
    extractJSON(text) {
      // پیدا کردن هر JSON که بین ``` قرار دارد
      const match = text.match(/```([\s\S]*?)```/);

      if (match && match[1]) {
        try {
          return JSON.parse(match[1]);
        } catch (e) {
          console.error("JSON parsing error:", e);
        }
      }

      // در صورتی که داخل ``` نبود، تلاش می‌کنیم از { تا } استخراج کنیم
      const jsonMatch = text.match(/\{[\s\S]*\}/);
      if (jsonMatch) {
        try {
          return JSON.parse(jsonMatch[0]);
        } catch (e) {
          console.error("JSON parsing error:", e);
        }
      }

      return null;
    },

    async aiRequest() {
      // let newLayer = `{"id":"qowcix2v8s01oi19bmd82b","name":"m-a","slots":{"default":{"text":"mixitweb mixitweb mixitweb mixitweb mixitweb mixitweb mixitweb mixitweb mixitweb ","components":[]}},"props":{"href":"https://papooshdez.com/","target":"_self"},"css":"","class":"text-dark","detail":{"tag":{"folder":"Tags","name":"A"}},"page":"SiteLayout","rawProps":{"href":{"default":"https://mixitweb.com"},"target":{"default":"_self"}},"dataAttribute":{}}`
      // return 1

      let axios = getAxiosInstance()
      let componentId = this.layer.id

      let form = {
        json: `${JSON.stringify(this.layer)}`,
        prompt: this.message || (this.imageDataUrl ? 'این طرح را با کامپوننت‌های MixitWeb پیاده کن' : ''),
        global_style: this.$store.getters['Site/getGlobalStyle'] || '',
        image: this.imageDataUrl || '',
      }

      const req = await axios.post(
          'https://n8n.mixitweb.com/webhook/ai-builder',
          form,
          {timeout: 0} // مهم برای n8n
      )

      const res = this.normalizeAiResponse(req.data)
      const cssChanged = res ? await this.applyGlobalCss(res) : false

      if (!res?.updated_json && !cssChanged) {
        console.error('AI response shape:', req.data)
        return
      }

      this.result = res.explanation || ''
      this.code = res.updated_json || res.css_block || res.global_style || ''

      if (res.updated_json) {
        let newLayer = this.sanitizeAiLayer(res.updated_json, this.layer)
        this.code = newLayer
        await this.$store.dispatch('Site/updateComponentValue', {componentId, newLayer});
      }


    }
  }
}
</script>

<style scoped>
.ai-image-preview {
  display: block;
  max-width: 100%;
  max-height: 180px;
  object-fit: contain;
  border: 1px solid #ddd;
  border-radius: 6px;
}
</style>